import type { Mating } from './mating.interface';

export interface cv_MatingStatus {
    Abbreviation: string;
    C_MatingStatus_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    IsExitStatus: boolean;
    Mating: Mating[];
    MatingStatus: string;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
